<template>
  <div class="input-adapter-check-single">
    <ul class="list-options-wrap">
      <li
        v-for="option in localOptions"
        :class="{ [`is-active`] : (option.key === localValue)}"
        @click="_onSelectOption(option)"
      >
        <div v-html="option.value"></div>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'InputAdapterCheckSingle',

    props: {
      title: {},
      options: {},
      value: {},
      cbs: {}
    },

    data () {
      let localOptions = this.options || []

      // { /// fix IT
      //   "option": "A",
      //   "subTitle": "没有经常咳痰",
      //   "score": 0
      // }

      // TODO: ----
      localOptions = localOptions.map(rawOption => {
        return {
          key: rawOption.subCode,
          value: `<strong>${rawOption.subTitle}</strong>`,
          rawRef: rawOption
        }
      })

      return {
        localValue: this.value,
        localOptions
      }
    },

    created () {
      this.$watch('valueStr', text => {
        this.cbs && this.cbs.setResponseValue(text || '未设置')
      }, {
        immediate: true
      })

      this.$watch('localValue', (val) => {
        this.cbs && this.cbs.syncLocalInputValue(val)
      }, {
        immediate: true
      })

      this.cbs && this.cbs.setNoActionsControl()
    },

    methods: {
      _onSelectOption (option) {
        this.localValue = option.key

        // TODO: diff value
        this.$nextTick(() => {
          const valueSelected = Array.isArray(this.localValue) ? !!this.localValue.length : this.localValue

          if (valueSelected && this.cbs) {
            this.cbs.tryNextCardItem(option.rawRef)
          }
        })
      }
    },

    computed: {
      valueStr () {
        let out = ''
        let v = this.localValue

        this.localOptions.some(o => {
          if (o.key === v) {
            out += `${o.value}`
            return true
          }
        })

        return out
      }
    }
  }
</script>

<style lang="scss">
  .input-adapter-check-single {
    > .list-options-wrap {
      padding: 0;
      list-style: none;
      margin: 0;

      > li {
        padding: 8px;
        border-radius: 20px;
        border: 1px solid #3DD3CB;
        margin-bottom: 10px;
        user-select: none;
        text-align: center;
        color: #3DD3CB;
        line-height: 1.1em;
        letter-spacing: 1px;

        &:active {
          opacity: .6;
        }

        &.is-active {
          background-color: #3DD3CB;
          color: white;
        }
      }
    }
  }
</style>
